export interface CommitteeInfo {
  id: string;
  number: string;
  name: string;
  abbreviation: string;
  fullName: string;
  description: string;
  agenda: string;
  executiveBoard: string;
  category: 'International' | 'Indian Parliamentary' | 'Crisis & Specialized' | 'Auction';
  track: 'Conventional' | 'Auction';
  formUrl: string;
}

export interface LeaderInfo {
  id: string;
  role: string;
  name: string;
  title: string;
  shortBio: string;
  letterTitle: string;
  letterParagraphs: string[];
  signatureNote: string;
}

export interface AdvisorInfo {
  id: string;
  number: string;
  name: string;
  title: string;
  image: string;
  affiliations: string[];
  paragraphs: string[];
  isPlaceholder?: boolean;
}

const REGISTRATION_LINKS = {
  conventionalCommittees: "https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform",
  auctionCommittees: "https://docs.google.com/forms/d/1aZ_JDtwvM5adaHJK-5STyKYu8jj1Vzd7pdFBzj609BE/viewform",
  organisingCommittee: "https://docs.google.com/forms/d/e/1FAIpQLSfSiv_ffmWpog6Dg_EfKIlOb_AKxcHYUydydEFOFoh7F6G-rA/viewform",
  campusAmbassador: "https://docs.google.com/forms/d/e/1FAIpQLScoVQuA_CGdVk0F2Rb0HEQAo2qHKR1tvhfDt6m1GbvX9UV4hg/viewform",
};

export const SUMMIT_CONFIG = {
  conferenceName: "FLSxMUN 2.0",
  shortName: "FLSxMUN 2.0",
  tagline: "FOR THE YOUTH, BY THE YOUTH.",
  dates: "19th & 20th DECEMBER",
  datesFull: "19th & 20th DECEMBER 2026",
  venue: "G H Raisoni Sadar Campus, Nagpur",
  venueMapUrl: "https://www.google.com/maps/search/?api=1&query=G+H+Raisoni+College+of+Arts+Commerce+Science+Sadar+Nagpur&utm_source=chatgpt.com",
  founder: "BHAVESH KUBDE",
  president: "RUTURAJ LONKAR",
  secretaryGeneral: "JANVI SAHANI",
  registrationYear: "2026",
  registrationLinks: REGISTRATION_LINKS,
  contactEmail: "futureleaderssummitofficial@gmail.com",
  socialLinks: {
    instagram: "https://www.instagram.com/future.leaders.summit/",
    instagramHandle: "@future.leaders.summit",
  },
  heroSupportingText: "An immersive Model United Nations experience designed to challenge perspectives, sharpen diplomacy and bring the next generation of leaders together.",
  aboutParagraphOne: "FLSxMUN 2.0 is a premier Model United Nations platform built by young people for young people. It is designed to encourage informed debate, diplomacy, strategic thinking, leadership and collaboration.",
  aboutParagraphTwo: "FLSxMUN 2.0 brings delegates into environments where they can question assumptions, defend positions, negotiate with opposing perspectives and experience the complexity of decision-making.",
  statistics: [
    { value: "09", label: "COMMITTEES", description: "Rigorous arenas of simulation" },
    { value: "01", label: "SUMMIT", description: "United diplomatic standard" },
    { value: "19-20", label: "DECEMBER", description: "19th & 20th December 2026" },
  ],
  advisors: [
    {
      id: "dr-madhura-rathod",
      number: "01",
      name: "DR. MADHURA RATHOD",
      title: "Associate Professor, Smt. Manoramabai Mundle College of Architecture | Governing Council Member, INTACH New Delhi",
      image: "/advisors/dr-madhura-rathod.jpg",
      affiliations: [
        "Ph.D. in Architecture",
        "INTACH Governing Council",
        "VNIT Alumna",
        "Heritage Conservation Committee"
      ],
      paragraphs: [
        "Dr. Madhura Rathod is an Associate Professor at Smt. Manoramabai Mundle College of Architecture, Nagpur, with over 25 years of experience in architectural education and practice. An alumna of VNIT, Nagpur, she holds a Ph.D. in Architecture from RTM Nagpur University, with research focused on the role of human senses in architecture.",
        "She is a Governing Council Member of INTACH, New Delhi, Co-Convenor for Maharashtra (Vidarbha), and Convenor of the INTACH Nagpur Chapter, member of Heritage Conservation Committee, Nagpur Municipal Corporation, and on the Advisory Board of Chapter Division of INTACH new Delhi.",
        "Her professional and research interests include heritage conservation, Indian architectural traditions, sensory architecture, documentation, museums, and indigenous knowledge systems. She has guided undergraduate, postgraduate and Ph.D students and has presented and published research in the field of architecture, education and heritage."
      ]
    },
    {
      id: "rtn-abhay-harane",
      number: "02",
      name: "RTN. ABHAY HARANE",
      title: "Advisor | Managing Director, Swaavalamban Estates Pvt. Ltd. | Rotarian",
      image: "/advisors/rtn-abhay-harane.png",
      affiliations: [
        "Managing Director, Swaavalamban Estates",
        "VNIT Engineering Alumnus",
        "Active Rotary Leader",
        "First-Generation Entrepreneur"
      ],
      paragraphs: [
        "A first-generation entrepreneur, engineering alumnus of VNIT Nagpur, and business leader, Rtn. Abhay Harane brings rich industry acumen and organizational leadership to the Advisory Board.",
        "As the Managing Director of Swaavalamban Estates Pvt. Ltd. and an active Rotary leader having served across pivotal administrative and executive roles—he exemplifies vision, resilience, and community impact.",
        "At FLSxMUN, his mentorship guides delegates in strategic execution, leadership, and bridging academic discourse with real-world enterprise."
      ]
    },
    {
      id: "ms-vasudha-paul",
      number: "03",
      name: "MS. VASUDHA PAUL",
      title: "Maharashtra State Coordinator – UNESCO Association Guwahati | Lead Food Safety Consultant – AIB International (USA) | Founder – Navninaad Foundation",
      image: "/advisors/vasudha-paul.jpg",
      affiliations: [
        "UNESCO State Coordinator",
        "Lead Consultant, AIB International (USA)",
        "Founder, Navninaad Foundation",
        "FSPCA Certified PCQI Trainer",
        "M.Sc. Microbiology & MDBA",
        "24+ Years Industry Experience"
      ],
      paragraphs: [
        "Scientist by training, teacher at heart, and auditor by profession, Ms. Vasudha Paul brings over 30 years of extensive experience in the field of food safety, quality assurance, auditing, consulting and professional training, and corporate social responsibility. Currently associated with AIB International (USA) as a Lead Food Safety Consultant, her professional journey spans manufacturing, certification, consulting and training, with experience at reputed organisations including Dinshaw's, Top N Town, Bureau Veritas and Diversey.",
        "She holds an M.Sc. in Microbiology and an MDBA, along with certifications in Six Sigma Green Belt, Lead Auditing for ISO 22000, FSSC 22000, HACCP, QMS and BRC. She is also an FSPCA-certified Preventive Controls Qualified Individual (PCQI) Trainer for FSMA and a Food Defence Coordinator. Her professional accomplishments include conducting 1000+ man-days of GMP audits across 14 countries, handling international certification files and training professionals from reputed organisations such as Coca-Cola, Taj, PizzaExpress and United Breweries.",
        "Beyond her corporate career, she believes in developing products, strengthening systems and, most importantly, developing people. She is also the Founder of Navninaad Foundation, an initiative focused on bringing food safety awareness into civic society. She has pursued her Management Certification in Social Initiatives programme at IIM Kozhikode, and is widely appreciated for her social initiatives taken for small food vendors.",
        "In addition to her professional contributions, she serves as the Maharashtra State Coordinator of UNESCO Association Guwahati, contributing to initiatives that encourage education, collaboration, social responsibility and community engagement. We are privileged to have her experience, expertise and guidance as a member of the Advisory Board of FLSxMUN 2.0, where her multidisciplinary perspective will be invaluable in guiding young minds towards leadership and responsible citizenship."
      ]
    }
  ] as AdvisorInfo[],
  leaders: [
    {
      id: "founder",
      role: "FOUNDER",
      name: "BHAVESH KUBDE",
      title: "Founder — FLSxMUN 2.0",
      shortBio: "Architect of the FLS vision, dedicated to creating an uncompromised diplomatic sanctuary where youth dialogue shapes tomorrow's discourse.",
      letterTitle: "A WORD FROM THE FOUNDER",
      letterParagraphs: [
        "Distinguished Delegates, Guests, and Future Leaders,",
        "When FLSxMUN was conceived, our intention was unequivocal: to dismantle the inertia of conventional youth conferences and replace it with a platform rooted in intellectual rigor, sovereign dialogue, and uncompromising young leadership.",
        "We believe diplomacy is not an ornamental exercise in recitation, but the most demanding art form of human civilization—the capacity to confront divergent interests, stand unflinchingly for conviction, and still forge consensus across ideological chasms.",
        "To every delegate stepping through our digital and diplomatic colonnades: you are not merely rehearsing for the future. You are articulating it right now.",
        "Welcome to FLSxMUN 2.0."
      ],
      signatureNote: "Bhavesh Kubde\nFounder, FLSxMUN 2.0"
    },
    {
      id: "president",
      role: "PRESIDENT",
      name: "RUTURAJ LONKAR",
      title: "President — FLSxMUN 2.0",
      shortBio: "Spearheading institutional excellence, strategic diplomacy, and structural integrity across all conference chambers.",
      letterTitle: "A WORD FROM THE PRESIDENT",
      letterParagraphs: [
        "Esteemed Delegates and Honored Participants,",
        "Leadership is tested in moments of genuine tension. The mark of a true diplomat is not the applause received at the podium, but the quiet, relentless patience required to build common ground when disagreement seems absolute.",
        "At FLSxMUN 2.0, our commitment as the Secretariat and Organizing Directorate is to construct an institutional arena that challenges your stamina, sharpens your policy mastery, and demands authenticity in every resolution.",
        "Enter these chambers prepared to interrogate the orthodoxies of the day, to listen with the same fierce focus as you speak, and to elevate the caliber of discourse to international stature.",
        "I look forward to witnessing your statecraft on the floor."
      ],
      signatureNote: "Ruturaj Lonkar\nPresident, FLSxMUN 2.0"
    },
    {
      id: "secretary_general",
      role: "SECRETARY GENERAL",
      name: "JANVI SAHANI",
      title: "Secretary General — FLSxMUN 2.0",
      shortBio: "Guiding the academic agenda, parliamentary procedure, and debate excellence across all specialized committees.",
      letterTitle: "A WORD FROM THE SECRETARY GENERAL",
      letterParagraphs: [
        "Distinguished Delegates and Parliamentary Observers,",
        "It is my distinct privilege to welcome you to the academic heart of FLSxMUN 2.0. Across our carefully curated committees, we have structured crises, legislative arenas, and international bodies that will test your intellectual resilience.",
        "From the solemn multilateral halls of the UNGA and ECOSOC, to the fiery democratic clashes of Lok Sabha and AIPPM, through the volatile crisis simulations of Rajputana Yuddh Parishad and Dead Poets Society, and into the high-stakes auction dynamics of FIFA and IPL, every arena demands consummate preparation and procedural mastery.",
        "Diplomacy without substance is mere theatrics; knowledge without conviction is sterile. In these chambers, let your rhetoric be grounded in truth, your alliances forged in trust, and your resolutions built to endure.",
        "The floor is yours."
      ],
      signatureNote: "Janvi Sahani\nSecretary General, FLSxMUN 2.0"
    }
  ] as LeaderInfo[],
  committees: [
    {
      id: "unga",
      number: "01",
      name: "UNGA",
      abbreviation: "UNGA",
      fullName: "United Nations General Assembly",
      description: "Strengthening International Nuclear Security and Strategic Stability Amidst Emerging Technologies and Challenges to Existing Arms-Control Mechanisms.",
      agenda: "Strengthening International Nuclear Security and Strategic Stability Amidst Emerging Technologies and Challenges to Existing Arms-Control Mechanisms",
      executiveBoard: "TO BE ANNOUNCED",
      category: "International",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "ecosoc",
      number: "02",
      name: "ECOSOC",
      abbreviation: "ECOSOC",
      fullName: "United Nations Economic and Social Council",
      description: "Discussion on the weaponisation of Economic Interdependence, with special emphasis on the disruption of trade routes running through the Middle East and South Asia.",
      agenda: "Discussion on the weaponisation of Economic Interdependence, with special emphasis on the disruption of trade routes running through the Middle East and South Asia.",
      executiveBoard: "TO BE ANNOUNCED",
      category: "International",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "lok-sabha",
      number: "03",
      name: "LOK SABHA",
      abbreviation: "LOK SABHA",
      fullName: "House of the People",
      description: "Reconciling Electoral Integrity with Representative Equality; with a special emphasis on SIR, CEC & other EC Act,2023 and future Redistribution of Lok Sabha Seats.",
      agenda: "Reconciling Electoral Integrity with Representative Equality; with a special emphasis on SIR, CEC & other EC Act,2023 and future Redistribution of Lok Sabha Seats",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Indian Parliamentary",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "aippm",
      number: "04",
      name: "AIPPM",
      abbreviation: "AIPPM",
      fullName: "All India Political Parties Meet",
      description: "Discussion and Deliberation in regards to Student Unions with a special Emphasis on rising cases of Malpractice and Violence during Student Body Elections.",
      agenda: "Discussion and Deliberation in regards to Student Unions with a special Emphasis on rising cases of Malpractice and Violence during Student Body Elections.",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Indian Parliamentary",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "rajputana-yuddh-parishad",
      number: "05",
      name: "RAJPUTANA YUDDH PARISHAD",
      abbreviation: "RAJPUTANA YUDDH PARISHAD (CCC)",
      fullName: "Rajputana Yuddh Parishad (Continuous Crisis Committee)",
      description: "The defence of Mewar against Mughal Expansion and Struggle of Rajput Sovergnity.",
      agenda: "The defence of Mewar against Mughal Expansion and Struggle of Rajput Sovergnity.",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Crisis & Specialized",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "dead-poets-society",
      number: "06",
      name: "DEAD POETS SOCIETY",
      abbreviation: "DEAD POETS SOCIETY (CCC)",
      fullName: "Dead Poets Society",
      description: "The Welton Crisis: Assessing Institutional and Parental Responsibility, Student Welfare, and Individual Expression in the Aftermath of the Neil Perry Case and the John Keating Affair.",
      agenda: "The Welton Crisis: Assessing Institutional and Parental Responsibility, Student Welfare, and Individual Expression in the Aftermath of the Neil Perry Case and the John Keating Affair.",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Crisis & Specialized",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "ip",
      number: "07",
      name: "IP",
      abbreviation: "IP",
      fullName: "International Press",
      description: "Photojournalism & Journalism across all committee chambers, investigative reporting, and live press conferences.",
      agenda: "Photojournalism & Journalism",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Crisis & Specialized",
      track: "Conventional",
      formUrl: REGISTRATION_LINKS.conventionalCommittees,
    },
    {
      id: "fifa",
      number: "08",
      name: "FIFA",
      abbreviation: "FIFA (AUCTION)",
      fullName: "FIFA — Mega Auction",
      description: "Mega auction simulation, international football franchise management, squad building, and purse negotiations.",
      agenda: "Mega auction",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Auction",
      track: "Auction",
      formUrl: REGISTRATION_LINKS.auctionCommittees,
    },
    {
      id: "ipl",
      number: "09",
      name: "IPL",
      abbreviation: "IPL (AUCTION)",
      fullName: "IPL — Player Auction",
      description: "Live IPL auction simulation, franchise dynamics, bidding strategy, player purse management, and squad optimization.",
      agenda: "Auction",
      executiveBoard: "TO BE ANNOUNCED",
      category: "Auction",
      track: "Auction",
      formUrl: REGISTRATION_LINKS.auctionCommittees,
    }
  ] as CommitteeInfo[],
  classOptions: [
    "Class 8",
    "Class 9",
    "Class 10",
    "Class 11",
    "Class 12",
    "Undergraduate",
    "Postgraduate",
    "Other"
  ]
};
